module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/gatsby/~/core-js/library/modules/_fails.js
// module id = 49
// module chunks = 168707334958949